import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import {Taggable, ThirdpartySystemResourceTypeFields, Trailer, TrailerOperationType, User} from 'shared';
import {TrailerService} from '../stores/trailer.service';
import tagsIcon from '@iconify/icons-mdi/id-card';
import {TrailerOperationTypeService} from '../stores/trailer-operation-type.service';
import {merge} from 'lodash';
import {DxDataGridComponent} from 'devextreme-angular';
import {ThirdpartySystemService} from '../stores/thirdparty-system.service';

@Component({
  selector: 'app-trailers-grid',
  templateUrl: './trailers-grid.component.html',
  styleUrls: ['./trailers-grid.component.scss']
})
export class TrailersGridComponent implements OnInit {

  ds: DataSource;
  canEdit: boolean;
  canAdd: boolean;
  canDelete: boolean;
  canListTags: boolean;
  canListThirdPartSystems: boolean;
  canEditThirdPartSystems: boolean;

  operations: TrailerOperationType[];
  tagsIcon = tagsIcon;
  tagsPopupVisible: boolean;
  taggable: Taggable;
  isSubContract: boolean;

  systemFieldsObject = 'thirdparty_systems';
  systemColumns = [];

  @ViewChild(DxDataGridComponent, {static: true})
  grid: DxDataGridComponent;

  constructor(
    private trailerService: TrailerService,
    private trailerOperationTypeService: TrailerOperationTypeService,
    private thirdpartySystemService: ThirdpartySystemService,
    public user: User,
  ) {

    // Permissions
    this.canEdit = user.can('edit trailers');
    this.canAdd = user.can('add trailers');
    this.canDelete = user.can('delete trailers');
    this.canListTags = user.can('list tags');
    this.canListThirdPartSystems = user.can('list thirdparty_systems');
    this.canEditThirdPartSystems = user.can('edit thirdparty_systems');

    // Data source
    this.ds = trailerService.newDataSource();

    // Get custom data
    this.ds.store().on('loaded', (result) => {
      if (!result.hasOwnProperty('custom') || !result.custom) {
        return;
      }
      if (!this.canListThirdPartSystems && !this.canEditThirdPartSystems) {
        return;
      }
      this.systemColumns = result.custom.thirdparty_systems_fields.map((d) => {
        return new ThirdpartySystemResourceTypeFields(d);
      }).reduce((all, current) => {
        all.push(...current.toColumns(this, this.systemFieldsObject));
        return all;
      }, []);

      // this.systemColumns.forEach(c => this.grid.instance.addColumn(c));
    });

    // Operations
    const operationsDs = trailerOperationTypeService.newDataSource();
    operationsDs.load().then(l => {
      this.operations = l;
    });

    // Bindings
    this.codeValidation = this.codeValidation.bind(this);
  }

  ngOnInit() {
  }

  onEditingStart(e: any) {
    this.isSubContract = e.data.is_subcontract;
  }

  onInitNewRow(e: any) {
    this.isSubContract = false;
  }

  showTags(e: MouseEvent, data: Trailer) {
    e.preventDefault();
    this.taggable = data;
    this.tagsPopupVisible = true;
  }

  codeValidation(params: any) {
    return this.trailerService.checkCode(params.value, params.data?.id).toPromise();
  }

  onRowUpdating(e: any) {
      e.newData[this.systemFieldsObject] = merge(e.oldData[this.systemFieldsObject], e.newData[this.systemFieldsObject]);
  }

  checkCode(params: any, system: string, field: string) {
    return this.thirdpartySystemService.checkUnique('TRAILER', {
      system,
      field,
      value: params.value,
      id: params.data?.id,
    }).toPromise();
  }

  subContractChange(e: any, cellInfo) {
    cellInfo.setValue(e.value);
    this.isSubContract = e.value;
  }
}
